import Api from '@/services/Api';

export default {
	async getStages() {
		return await Api.get('/api/stages');
	},
	async getStage(id) {
		return await Api.get(`/api/stage/${id}`);
	},
	async storeStage(title, type, status, color, colorId, datepicker) {
		return await Api.post('/api/stage', { title, type, status, color, color_id: colorId, datepicker });
	},
	async updateStage(id, title, type, status, color, colorId, datepicker) {
		return await Api.patch(`/api/stage/${id}`, { title, type, status, color, color_id: colorId, datepicker });
	},
	async deleteStage(id) {
		return await Api.delete('/api/stage', { data: { stage_id: id } });
	},
	async getDeletedStages() {
		return await Api.get('/api/stages/deleted');
	},
	async getStageHistory(pivot) {
		return await Api.post('/api/get-stage-history', pivot);
	},
	async sendPDF(obj) {
		return await Api.post('api/send-pdf', obj);
	},
	async updateStageNote(obj) {
		return await Api.post('api/stage/update-note', obj);
	}
};
